module.exports = fox._r("images/sprite-small-preloader-blue.png", __webpack_public_path__ + "_/_/_/root/images/sprite-small-preloader-blue.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/sprite-small-preloader-blue.png
// module id = 50
// module chunks = 4